import { ChangeEvent, memo, ReactElement } from "react";
import { getCheckboxTestIdByText } from "e2e-tests/testIds";

interface CheckboxConsentProps {
    checked?: boolean;
    label: string | ReactElement;
    onChange: (value: boolean) => void;
}
const CheckboxConsent = ({ checked = false, label, onChange }: CheckboxConsentProps) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return (
        <div className="checkbox-consent grid grid-flow-col items-center justify-start gap-4">
            <input
                id="zing-checkbox"
                className="hover:cursor-pointer"
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                data-zing-test-id={getCheckboxTestIdByText("consent")}
            />
            <label
                htmlFor="zing-checkbox"
                className="text-zing-12-18 font-normal text-zing-gray-100 hover:cursor-pointer female:text-zing-neutral-cool-grey-600"
            >
                {label}
            </label>
        </div>
    );
};
export default memo(CheckboxConsent);
